import localStore from '@theme/local-store'
import { Component } from '@theme/component'

class VehicleList extends Component {
  constructor() {
    super()
    this._onMakeChanged = this._onMakeChanged.bind(this)
    this._onVehicleChanged = this._onVehicleChanged.bind(this)
  }

  connectedCallback() {
    super.connectedCallback?.()
    requestAnimationFrame(() => this._init())
    document.addEventListener('vehicle-make:changed', this._onMakeChanged)
    document.addEventListener('vehicle:changed', this._onVehicleChanged)
  }

  disconnectedCallback() {
    document.removeEventListener('vehicle-make:changed', this._onMakeChanged)
    document.removeEventListener('vehicle:changed', this._onVehicleChanged)
    super.disconnectedCallback?.()
  }

  _init() {
    const groups = this._groups()
    if (!groups.length) return

    let make = localStore.get('vehicle_make', null)
    if (!make) make = this.getAttribute('data-default-make') || null
    if (!make) make = groups[0]?.getAttribute('data-make') || ''

    this.applyMake(make)
  }

  /** @returns {NodeListOf<HTMLElement>} */
  _groups() {
    return this.querySelectorAll('[data-make]')
  }

  /** Cambia el make visible y actualiza label */
  applyMake(makeHandle) {
    const groups = this._groups()
    if (!groups.length) return
    let visible = null

    groups.forEach((g) => {
      const make = g.getAttribute('data-make')
      const isMatch = make === makeHandle

      if (!makeHandle) {
        g.removeAttribute('hidden')
        visible = g
      } else if (isMatch) {
        g.removeAttribute('hidden')
        visible = g
      } else {
        g.setAttribute('hidden', '')
      }
    })

    const valueSpan = this.querySelector('.vehicle-value')
    if (valueSpan) {
      const stored = this._readStoredVehicle()
      let text = ''

      if (stored?.vehicle) {
        try {
          const node = this.querySelector(
            `[data-vehicle="${CSS.escape(stored.vehicle)}"]`
          )
          if (node) {
            // Usa el label almacenado o calcula desde el nodo
            const labelFromStore = stored?.label && String(stored.label).trim()
            text = labelFromStore || this._vehicleLabel(node, stored.vehicle)
          }
        } catch (_) {
          // noop
        }
      }

      // Solo imprime si el vehículo existe dentro de este <vehicle-list>
      valueSpan.textContent = text
    }
  }

  /** Lee la selección de vehículo guardada en localStore */
  _readStoredVehicle() {
    try {
      let stored = localStore.get('vehicle', null)
      if (!stored) return null
      if (typeof stored === 'string') {
        try {
          stored = JSON.parse(stored)
        } catch (_) {}
      }
      if (stored && typeof stored === 'object') return stored
      return null
    } catch (_) {
      return null
    }
  }

  /** Evento cuando cambia el vehículo */
  _onVehicleChanged(e) {
    const make = e?.detail?.make
    if (typeof make === 'string' && make) {
      this.applyMake(make)
    } else {
      this.applyMake(
        localStore.get(
          'vehicle_make',
          this.getAttribute('data-default-make') || ''
        )
      )
    }
    this._closeDetails()
  }

  /** Cierra cualquier <details> abierto dentro del componente */
  _closeDetails() {
    this.querySelectorAll('details[open]').forEach((d) => {
      d.removeAttribute('open')
    })
  }

  _vehicleLabel(container, fallbackHandle) {
    if (!container) return this._capitalizeHandle(fallbackHandle)

    const byData = container.querySelector(
      '[data-vehicle-label], [data-vehicle-name]'
    )
    if (byData?.textContent) return byData.textContent.trim()

    const candidates = [
      '.vehicle-card__link',
      '.vehicle-card h3',
      '.block-vehicle h3',
      '.block-vehicle [aria-label]',
      'a[aria-label]',
    ]
    for (const sel of candidates) {
      const el = container.querySelector(sel)
      if (el) {
        const t = (el.getAttribute('aria-label') || el.textContent || '').trim()
        if (t) return t
      }
    }

    return this._capitalizeHandle(fallbackHandle)
  }

  _capitalizeHandle(handle) {
    if (!handle) return ''
    return handle
      .split('-')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ')
  }

  /** Evento cuando cambia el make */
  _onMakeChanged(e) {
    const make = e?.detail?.make

    this.applyMake(make)
    this._closeDetails()
  }
}

if (!customElements.get('vehicle-list')) {
  customElements.define('vehicle-list', VehicleList)
}
